// extracted by mini-css-extract-plugin
export var banner = "unibetBanner-module--banner--nqNw8";
export var banner__adMark = "unibetBanner-module--banner__adMark--ZrjpI";
export var banner__container = "unibetBanner-module--banner__container--+ajZ2";
export var banner__demo = "unibetBanner-module--banner__demo--ecWOO";
export var banner__desktop = "unibetBanner-module--banner__desktop--VNCPU";
export var banner__mobile = "unibetBanner-module--banner__mobile--VJKqI";